var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rc"},[_c('div',{staticClass:"lt-left"},[_c('div',{ref:"cmain1",staticClass:"cmain",style:({ width: '460px', height: '220px' })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }